/** 
 * Copyright (c) INOVUA SOFTWARE TECHNOLOGIES.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _detectUa = require("../../../detect-ua");

var _Menu = _interopRequireDefault(require("../../../packages/Menu"));

var _renderGridMenu = _interopRequireDefault(require("../../../renderGridMenu"));

var ROW_MENU_ALIGN_POSITIONS = ['tl-bl', 'tr-br', 'tl-tr', 'tr-tl', 'br-tr', 'bl-tl', 'br-tl', 'bl-tr', 'lc-tr', 'rc-tl'];
var ROW_MENU_ALIGN_POSITIONS_RTL = ['tr-br', 'tl-bl', 'tr-tl', 'tl-tr', 'br-tr', 'bl-tl', 'br-tl', 'bl-tr', 'lc-tr', 'rc-tl'];

var notEmpty = function notEmpty(x) {
  return !!x;
};

var getTopComputedProps = function getTopComputedProps(computedProps) {
  while (computedProps.initialProps.parentComputedProps) {
    computedProps = computedProps.initialProps.parentComputedProps;
  }

  return computedProps;
};

var _default = function _default(computedProps, computedPropsRef) {
  var rowProps = computedProps.rowContextMenuProps;

  if (!rowProps) {
    return null;
  }

  var rowContextMenuInfo = computedProps.rowContextMenuInfoRef;

  if (!rowProps || !rowContextMenuInfo.current) {
    return null;
  }

  var cellProps = rowContextMenuInfo.current.cellProps;
  var constrainToComputedProps = getTopComputedProps(computedProps);
  var items = [];
  var menuProps = {
    updatePositionOnScroll: computedProps.updateMenuPositionOnScroll,
    maxHeight: constrainToComputedProps.initialProps.columnContextMenuConstrainTo ? null : computedProps.getMenuAvailableHeight(),
    autoFocus: true,
    theme: computedProps.theme,
    onDismiss: computedProps.hideRowContextMenu,
    nativeScroll: !_detectUa.IS_MS_BROWSER,
    style: {
      zIndex: 110000,
      position: computedProps.initialProps.rowContextMenuPosition || 'absolute'
    },
    items: items,
    constrainTo: constrainToComputedProps.columnContextMenuInfoRef.current.getMenuConstrainTo(),
    alignPositions: computedProps.initialProps.rowContextMenuAlignPositions || computedProps.rtl ? ROW_MENU_ALIGN_POSITIONS_RTL : ROW_MENU_ALIGN_POSITIONS,
    alignTo: computedProps.rowContextMenuInfoRef.current.menuAlignTo
  };
  var result;

  if (computedProps.initialProps.renderRowContextMenu) {
    result = computedProps.initialProps.renderRowContextMenu(menuProps, {
      rowProps: rowProps,
      cellProps: cellProps,
      grid: computedProps.publicAPI,
      computedProps: computedProps,
      computedPropsRef: computedPropsRef
    });
  }

  if (result === undefined) {
    result = _react.default.createElement(_Menu.default, Object.assign({}, menuProps));
  }

  if (computedProps.initialProps.renderGridMenu) {
    return computedProps.initialProps.renderGridMenu(result, computedProps);
  }

  return (0, _renderGridMenu.default)(result, computedProps);
};

exports.default = _default;